<script setup>
import LandingPageLayout from '@/Layouts/LandingPageLayout.vue';
import { Link } from '@inertiajs/inertia-vue3';

const posts = [
    {
        id: 1,
        title: 'Sol Aerial Surveys',
        href: '/case-studies/solaerial',
        description:
            'The founder of Sol Aerial Surveys, Peter Makredes, needed a better way to manage his fleet of twin Cessna aircraft that he uses to perform aerial surveys all around the United States.',
        category: { title: 'Scaling Smarter', href: '/case-studies/solaerial' },
        author: {
            name: 'Sol Aerial Surveys',
            role: 'Streamlining Maintenance and Compliance',
            href: '/case-studies/solaerial',
            imageUrl:
                'https://logixpublic.s3.amazonaws.com/case-studies/solaerial/solaeriallogo.png',
        },
    },
    {
        id: 2,
        title: 'DZONE Skydiving',
        href: '/case-studies/dzone',
        description:
            'The founder of DZONE Skydiving, Abbie Mashaal, needed a better way to manage his fleet of Cessna aircraft that he uses to deliver his customers to 13,000 feet MSL. One day the FAA requested an onsite visit with less than a day\'s notice, and thanks to PLANELOGIX, they were not only prepared, but invited the FAA examiner to come over immediately.',
        category: { title: 'Efficiency', href: '/case-studies/dzone' },
        author: {
            name: 'DZONE Skydiving',
            role: 'FAA Routine Investigation',
            href: '/case-studies/dzone',
            imageUrl:
                'https://logixpublic.s3.amazonaws.com/case-studies/dzone/dzone.jpg',
        },
    },
    {
        id: 3,
        title: 'Flying Out of Airworthiness Compliance',
        href: '/case-studies/ADs',
        description:
            'Lindsay investigated how many times we discovered for our clients that they were unknowingly flying out of compliance with ADs and FARs, and the results were shocking.',
        category: { title: 'Safety & Insurance', href: '/case-studies/ADs'},
    },
    {
        id: 4,
        title: 'Catching Errors and Omissions',
        href: '/case-studies/8130',
        description:
            'We catch errors and omissions that are routinely missed by all stakeholders (pilot, owner, and the shop).',
        category: { title: 'Errors and Omissions', href: '/case-studies/8130'},
    },
    {
        id: 5,
        title: 'Love Cloud',
        href: '/case-studies/lovecloud',
        description:
            'The owner and chief pilot of Love Cloud, Anthony Blake, needed help with the most critical and difficult to manage piece of his business.',
        category: { title: 'Necessity', href: '/case-studies/lovecloud' },
        author: {
            name: 'Love Cloud',
            role: 'Improving Business Operations',
            href: '/case-studies/dzone',
            imageUrl:
                'https://logixpublic.s3.amazonaws.com/case-studies/lovecloud/lovecloud.png',
        },
    },
    {
        id: 6,
        title: 'Papua New Guinea Export',
        href: '/case-studies/papua-new-guinea',
        description:
            'Jeff Root needed to export a Cessna Caravan and de Havilland Canada Twin Otter to Papua New Guinea. A CASAPNG inspector traveled all the way from Papa New Guinea to audit the records - and completed a 14-day task in just 4 days thanks to PLANELOGIX.',
        category: { title: 'International', href: '/case-studies/papua-new-guinea' },
        author: {
            name: 'CASAPNG',
            role: 'A Historic First for Digital Records',
            href: '/case-studies/papua-new-guinea',
            imageUrl:
                'https://logixpublic.s3.us-east-1.amazonaws.com/case-studies/CASAPNG/CASAPNG.jpg',
        },
    },
]

</script>

<template>
    <LandingPageLayout title="Case Studies">

        <div class="isolate overflow-hidden">
            <div class="flow-root bg-gray-900 py-16 sm:pt-32 lg:pb-30">
                <div class="mx-auto max-w-7xl px-6 lg:px-8">
                    <div class="relative z-10">
                        <h1 class="mx-auto max-w-4xl text-center text-5xl font-bold tracking-tight text-white">Case Studies</h1>
                        <p class="mx-auto mt-4 max-w-2xl text-center text-lg leading-8 text-white/60">Learn about how others are benefiting from PLANELOGIX</p>
                    </div>
                    <div class="relative mx-auto mt-10 grid max-w-md grid-cols-1 gap-y-8 lg:mx-0 lg:-mb-14 lg:max-w-none lg:grid-cols-2">
                        <svg viewBox="0 0 1208 1024" aria-hidden="true" class="absolute -bottom-48 left-1/2 h-[64rem] -translate-x-1/2 translate-y-1/2 [mask-image:radial-gradient(closest-side,white,transparent)] lg:-top-48 lg:bottom-auto lg:translate-y-0">
                            <ellipse cx="604" cy="512" fill="url(#d25c25d4-6d43-4bf9-b9ac-1842a30a4867)" rx="604" ry="512" />
                            <defs>
                                <radialGradient id="d25c25d4-6d43-4bf9-b9ac-1842a30a4867">
                                    <stop stop-color="#111827" />
                                    <stop offset="1" stop-color="#01b2ff" />
                                </radialGradient>
                            </defs>
                        </svg>
                        <div class="hidden lg:absolute lg:inset-x-px lg:bottom-0 lg:top-4 lg:block lg:rounded-t-2xl lg:bg-gray-800/80 lg:ring-1 lg:ring-white/10" aria-hidden="true" />
                    </div>
                </div>
            </div>
        </div>
        <div class="bg-white py-24 sm:py-32">
            <div class="mx-auto max-w-7xl px-6 lg:px-8">
                <div class="mx-auto max-w-2xl">
                    <!--<h2 class="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Case Studies</h2>
                    <p class="mt-2 text-lg leading-8 text-gray-600">Learn about how others are benefiting from PLANELOGIX</p>-->
                    <div class="space-y-16 ">
                        <article v-for="post in posts" :key="post.id" class="flex max-w-xl flex-col items-start justify-between">
                            <div class="flex items-center gap-x-4 text-xs">
                                <!--<time :datetime="post.datetime" class="text-gray-500">{{ post.date }}</time>-->
                                <h3 class="mt-3 text-lg font-semibold leading-6 text-gray-900 group-hover:text-gray-600">
                                    <Link :href="post.href">{{ post.title }}</Link>
                                </h3>
                                <Link :href="post.category.href" class="relative z-10 rounded-full bg-gray-50 px-3 py-1.5 font-medium text-gray-600 hover:bg-gray-100 mt-2 justify-end">{{ post.category.title }}</Link>
                            </div>
                            <div class="group relative">

                                <Link :href="post.category.href" class="mt-5 line-clamp-4 text-sm leading-6 text-gray-600">{{ post.description }}</Link>
                            </div>
                            <div class="relative mt-8 flex items-center gap-x-4">
                                <img v-if="post.author" :src="post.author.imageUrl" alt="" class="h-10 w-10 rounded-full bg-gray-50" />
                                <div v-if="post.author" class="text-sm leading-6">
                                    <p class="font-semibold text-gray-900">
                                        <Link :href="post.author.href">

                                            {{ post.author.name }}
                                        </Link>
                                    </p>
                                    <p class="text-gray-600">{{ post.author.role }}</p>
                                </div>
                                <Link :href="post.href" class="text-sm font-semibold leading-6 text-indigo-600">Continue reading <span aria-hidden="true">&rarr;</span></Link>
                            </div>
                            <div class="flex">
                            </div>
                        </article>
                    </div>
                </div>
            </div>
        </div>

    </LandingPageLayout>


</template>
